import React from 'react';
import UserCinemaNavLinks from './UserCinemaNavLinks';

interface Props {
  area: any;
  showInMobile?: boolean;
  areaSelector?: boolean | React.ReactNode;
  cinemaSelector?: boolean;
}

const UserAreaNav: React.FC<Props> = (props) => {
  return (
    <nav className={'container py-3 ' + (props.showInMobile === false ? 'd-none d-md-block' : '')}>
      <ul className="nav flex-nowrap justify-content-between align-items-center c-nav">
        <UserCinemaNavLinks
          areaSelector={props.areaSelector}
          cinemaSelector={props.cinemaSelector === false ? false : true}
          area={props.area}
        />
        </ul>
      </nav>
  );
}

export default UserAreaNav;